import { render, staticRenderFns } from "./scope53.vue?vue&type=template&id=5c998e76&scoped=true"
import script from "./scope53.vue?vue&type=script&lang=js"
export * from "./scope53.vue?vue&type=script&lang=js"
import style0 from "./scope53.vue?vue&type=style&index=0&id=5c998e76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c998e76",
  null
  
)

export default component.exports